'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { Disc3 } from 'lucide-react'
import { usePlayer } from '@/lib/player-context'

/**
 * Raccourci « OUVRIR LE LECTEUR » (à côté du bouton QR, près du logo).
 * Pensé pour la télécommande : Retour ramène le focus ICI (TvDesktopNav),
 * OK ouvre le grand lecteur. Le disque tourne quand la musique joue.
 * tvOnly : affiché uniquement sur TV (en-tête mobile = TV verticale).
 */
export default function PlayerShortcutButton({ className = '', size = 20, tvOnly = false }: { className?: string; size?: number; tvOnly?: boolean }) {
  const { playing, current } = usePlayer()
  const [tv, setTv] = useState(false)
  useEffect(() => { setTv(document.documentElement.classList.contains('tv')) }, [])
  if (tvOnly && !tv) return null
  return (
    <Link href="/app/player" data-player-shortcut="" title="Ouvrir le lecteur" aria-label="Ouvrir le lecteur"
      className={`blc-player-shortcut lglass shrink-0 grid place-items-center rounded-2xl text-white ${className}`}>
      <Disc3 size={size} className={playing && current ? 'animate-spin [animation-duration:3s]' : ''} />
    </Link>
  )
}
